//** NEW TEMPLATE

const S = el => document.querySelectorAll(el);

export default S;
